import angular from 'angular';
import _ from 'lodash';

export default angular.module('download-report-page-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      downloadReportsPack: {
        'INVALID_TOKEN': (paras) => ({
          title: gettextCatalog.getString('Reports generation failed.'),
          body: gettextCatalog.getString('Please refresh the page.')
        })
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/download-report-page/config/errorcodes.conf.js